export class ChecklistCompleteEdit{
    Id :number;
    AppManualChecklistId:number;
    Title:string;
    ResponsiblePerson:number;
    Participants:number;
    Status:number;
    IsCompleted:boolean;
}